import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLanguageFromPathname, getAlternatePath } from '../i18n/routes';
import { cn } from '../lib/utils';

export function LanguageSwitcher({ className = "", variant = "header" }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const currentLang = getLanguageFromPathname(pathname);

  const handleLanguageChange = (targetLang) => {
    if (targetLang === currentLang) return;
    const newPath = getAlternatePath(pathname, targetLang);
    navigate(newPath);
  };

  const isDark = variant === "dark" || variant === "footer";

  return (
    <div 
      className={cn(
        "inline-flex items-center rounded-full p-1 transition-colors border",
        isDark 
          ? "bg-stone-800/80 border-stone-700/80 text-stone-300" 
          : "bg-stone-100/90 border-stone-200/90 text-stone-700 shadow-xs",
        className
      )}
      aria-label="Sprog / Language"
    >
      {/* Danish Button */}
      <button
        type="button"
        onClick={() => handleLanguageChange('da')}
        className={cn(
          "flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer select-none",
          currentLang === 'da'
            ? (isDark 
                ? "bg-[#817262] text-white shadow-xs font-semibold" 
                : "bg-[#817262] text-white shadow-xs font-semibold")
            : (isDark 
                ? "hover:text-white hover:bg-stone-700/50 text-stone-300" 
                : "hover:text-stone-900 hover:bg-stone-200/60 text-stone-600")
        )}
        title="Dansk"
        aria-label="Dansk"
      >
        <span className="text-xs font-semibold tracking-wider">DK</span>
      </button>

      {/* English Button */}
      <button
        type="button"
        onClick={() => handleLanguageChange('en')}
        className={cn(
          "flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer select-none",
          currentLang === 'en'
            ? (isDark 
                ? "bg-[#817262] text-white shadow-xs font-semibold" 
                : "bg-[#817262] text-white shadow-xs font-semibold")
            : (isDark 
                ? "hover:text-white hover:bg-stone-700/50 text-stone-300" 
                : "hover:text-stone-900 hover:bg-stone-200/60 text-stone-600")
        )}
        title="English"
        aria-label="English"
      >
        <span className="text-xs font-semibold tracking-wider">GB</span>
      </button>
    </div>
  );
}

export default LanguageSwitcher;
